import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Button as AntButton } from "antd";
import globalColors from "../styles/globalColors";

type Props = {
  options: Array<{ value: string; label: string }>;
  selectedValue: string;
};

const PillGroup: React.FC<Props> = props => {
  return (
    <div>
      {props.options.map(option => {
        const isSelected = option.value === props.selectedValue;
        return (
          <AntButton
            key={option.value}
            css={[styles.button, isSelected && styles.buttonSelected]}
          >
            {option.label}
          </AntButton>
        );
      })}
    </div>
  );
};

const styles = {
  button: {
    borderColor: globalColors.gray,
    borderRadius: 20,
    fontWeight: 600,
    margin: 5,
    padding: "0 29px",
    ":hover, :focus": {
      color: globalColors.secondary,
      borderColor: globalColors.secondary
    }
  },
  buttonSelected: {
    backgroundColor: globalColors.secondary,
    borderColor: globalColors.secondary,
    color: globalColors.white,
    ":hover, :focus": {
      backgroundColor: "#90d2d0",
      borderColor: "#90d2d0",
      color: globalColors.white
    }
  }
};

export default PillGroup;
